import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Button, Form } from 'react-bootstrap';

import Testimonial from '../copmpnents/Testimonial/Testimonial.js';
import PasswordInput from '../../../components/PasswordInput';
import { activateAccount } from '../AuthActions';

import logo from './img/logo-nave-icon.svg';

// Import Style
import '../Auth.scss';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: '',
      password: '',
    };
  }

  componentDidMount() {
    this.setState({
      token: this.props.match.params.token,
    });
  }

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.activate({
      token: this.state.token,
      password: this.state.password,
    });
  };

  render() {
    return (
      <div className='login_bg'>
        <div className='login_form'>
          <div className='logo'>
            <img src={logo} alt="" />
          </div>
          <div className='login_content'>
            <div className='left_part'>
              <h1>Partner Portal</h1>
              <Form className='form' onSubmit={this.handleSubmit}>
                <PasswordInput
                  name="password"
                  id="password"
                  placeholder="New Password"
                  value={this.state.password}
                  onChange={this.handleChange}
                />
                <Button type="submit" className="mt-4" variant="primary">
                  Activate account
                </Button>
              </Form>
            </div>
            
            <div className='right_part'>
              <Testimonial />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    activate: (body) => dispatch(activateAccount(body)),
  };
};

export default withRouter(connect(undefined, mapDispatchToProps)(Login));
